import {
  UserSuspendedException,
  UserDeactivatedException,
  NotFoundException,
  UserBlockedException,
  UserSelfBlockedException,
} from '@wix/da-error-handling';
import { Url } from '@wix/da-url';
import { GallectionType } from '../../types/gallection';

export function handleExceptionThrown(e, req, res) {
  if (e.error) {
    // handle 400 user errors from PAPI
    const { error } = e;
    switch (error.errorCode) {
      case 0:
        return UserSuspendedException(`User is suspended`);
      case 1:
        return UserDeactivatedException(`User has been deactivated`);
      case 2:
        return NotFoundException(`Could not find user`);
      case 3:
        return UserBlockedException(
          `Sorry, you are unable to view this profile.`
        );
      case 4:
        return UserSelfBlockedException(
          `You have chosen to block this deviant.`
        );
      default:
    }
  } else if (e.name) {
    // handle our own internal errors
    switch (e.name) {
      case 'EmptyCollectionsFolderException':
        // If the requested collections folder is empty we want to throw a 404, unless
        // the user is refreshing the page after editing said collection (and leaving it empty).
        // In that particular case we redirect to the collections index.
        const referrer = req.get('Referrer');
        const isRefresh = referrer && referrer.endsWith(req.path);
        if (isRefresh) {
          res.redirect(
            Url.userGalleryPath({
              username: e.username,
              gallectionType: GallectionType.COLLECTION,
            })
          );
          return false; // do not throw error so that redirect works
        } else {
          return NotFoundException(e.message);
        }
      default:
        throw e;
    }
  }
}

export class EmptyCollectionsFolderException extends Error {
  name = 'EmptyCollectionsFolderException';
  username: string;

  constructor(username: string) {
    super('Collection folder is empty.');
    this.username = username;
  }
}
